import React, { useRef, useState, useContext } from 'react'
import {useForm} from 'react-hook-form';
import { useParams } from 'react-router-dom'
import NoteContext from '../context/note-context'
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const Add = () => {
  const params=useParams();
  const errorStyle={
    color: 'red'
    }
    
  // const giveError=()=>{
  //   throw new Error('Error....')
  //   }
    
      
  const {register,handleSubmit,formState:{errors},reset}=useForm();
  const [message,setMessage]= useState('');
  const nameref=useRef();
  const descref=useRef();
  const dateref=useRef();
  console.log(params);
  const noteContext=useContext(NoteContext);
  const [dateValue,setDateValue]=useState(dayjs('2022-04-17'));

    
    
  // const takeInput=()=>{
  //   const noteObject={
  //   title:nameref.current.value,
  //   desc:descref.current.value,
  //   date:dateref.current.value
  //   }
    // noteContext.addSingleNote(noteObject);

    // console.log('input is',noteObject);
    // setMessage(" Note Added");
    // }
    const getFormData=(formData)=>{
      console.log('Rec Data of form',formData);
      noteContext.addSingleNote(formData);
      setMessage('Note Added');
      }
      
      
    
  return (
    <form onSubmit={handleSubmit(getFormData)}>
      <h1> {params.operationsnname}Add Note{message}</h1>
<TextField {...register('title',{required:true, min:3, max:10})} id="outlined-basic" label="Title" variant="outlined"/>
{errors && errors.title && errors.title.type==='required' &&<p style={errorStyle}>Title can't be empty</p>}

<br/>
<br/>
<br/>
<TextField
{...register('desc', {
  validate:{
    checkLength:(value)=>value.length>7
  }
})}
id="outlined-multiline-static"
label="Desc"
multiline
rows={4}
/>
{errors && errors.desc && errors.desc.type==='checkLength' && 
<p style={errorStyle}>Length is small</p>}
<br/>
<br/>
<br/>

    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker {...register('date')}  value={dateValue} 
    onChange={(newValue)=>setDateValue(newValue)} label="Note Date"/>
    </LocalizationProvider>
<br/>
<br/>
<br/>
<div>
<Button type='submit' variant="contained" >Add Note</Button>&nbsp;&nbsp;
<Button  onClick={()=>{
reset({title:'', desc:'', date:setDateValue(dayjs('2020-01-01'))})
}} variant="contained"> Reset Note </Button>

</div>  
</form>
  )
}

export default Add